import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ContentType, StandardDialogData } from 'src/app/interfaces/mat.interface';

@Component({
  selector: 'app-standard-dialog',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './standard-dialog.html',
  styleUrls: ['./standard-dialog.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None,
})
export class StandardDialog {  
  public data: StandardDialogData = inject(MAT_DIALOG_DATA);  
  
  protected iconName = computed(() => {
    if (this.data.iconName) return this.data.iconName;
    
    if (this.isOnlyErrorList()) return 'error';
    
    return this.isSuccessList() ? 'warning' : undefined;
  })
  
  protected getTitleString(): string | undefined {
    const title = this.data.title;
    
    if (!title) return undefined;
    
    return this._isStringContent(title) ? title : undefined;
  }
  
  protected getContentString(): string | undefined {
    const content = this.data.content;
    if (!content) return undefined;
    
    return this._isStringContent(content) ? content : undefined;
  }
  
  protected isOnlyErrorList(): boolean {
    return !this.isSuccessList() && this.isErrorList();
  }
  
  protected isSuccessList(): boolean {
    const content = this.data.content as ContentType;
    if (!content) return false;
    
    return content.length > 0;
  }
  
  protected isErrorList(): boolean {
    const content = this.data.content as ContentType;
    if (!content) return false;

    return content.length > 0;
  }
  
  protected getTitleDialog(): string {
    const title = this.data.title;
    if (title) return title;
    
    return this.isOnlyErrorList() 
      ? 'No se ha podido modificar la ruta' 
      : 'Ruta modificada parcialmente';
  }
  
  // Type guards
  private _isStringContent(content: ContentType| undefined): content is string {
    return typeof content === 'string';
  }
}
